
import { Component, Prop, Vue } from "vue-property-decorator";
import Item from "@/views/paper/paper-result-report/component-new-h5/item.vue";
import LevelDetail from "@/views/paper/paper-result-report/component-new-h5/level-detail.vue";
import EnglishAssessmentResult from "@/views/paper/paper-result-report/english";
import { CandidateNewResult } from "@/lib/model/exam/candidate-result";

@Component({
  components: { Item, LevelDetail }
})
export default class EnglishProficiency extends Vue {
  @Prop({ type: CandidateNewResult, default: () => new CandidateNewResult() })
  all!: CandidateNewResult; //候选人信息 所有表

  get englishData() {
    const res = new EnglishAssessmentResult().assign(
      this.all.report.englishAssessmentResult
    );
    return res;
  }
  get tableList() {
    return this.englishData.getTable();
  }
  // 总评估
  get totalLevel() {
    const obj = this.englishData.getLevel("totalLevel", true);
    // 对 totalLevel 为0 做特殊判断
    if (this.englishData.totalLevel === 0) {
      obj.text = "";
      obj.color = "";
    }
    return obj;
  }
  // 表达流利度考察点
  get pronFluency() {
    return this.englishData.getLevel("pronFluencyLevel");
  }
  // 发音准确度考察点
  get pronAccuracy() {
    return this.englishData.getLevel("pronAccuracyLevel");
  }
  // 词汇丰富度考察点
  get lexicalRichness() {
    return this.englishData.getLevel("lexicalRichnessLevel");
  }
  // 语法准确度考察点
  get grammarAccuracy() {
    return this.englishData.getLevel("grammarAccuracyLevel");
  }
}
